import RemoveIcon from '@mui/icons-material/Remove';
import React from 'react';

const EmptyCell: React.FC = () => <RemoveIcon color="disabled" />;

export default EmptyCell;
